'use client';

/**
 * @ignore - internal component.
 */
function ToolbarActions() {
  return null;
}
export { ToolbarActions };